
(function ($) {
    $(function () {

        if ($('.js-template-search').length) {

            $('.js-clear-search').on('click', function (e) {
                e.preventDefault();
                $('.js-search').val('');
            });


            $('.js-search-menu').on('click', function (e) {
                e.preventDefault();
                var cid = $(this).data('id');
                $('.js-search-menu.active').removeClass('active');
                $(this).addClass('active');
                $('.js-search-menu-mobile')[0].sumo.selectItem(cid)

                if (cid == 'all') {
                    $('.js-result-section').show();
                } else {
                    $('.js-result-section').hide();
                    $(`.js-result-section#${cid}`).show();
                }

            })

            $('.js-search-menu-mobile').on('click', function (e) {
                e.preventDefault();
                var cid = $(this).val();

                $('.js-search-menu.active').removeClass('active');
                $(`.js-search-menu[data-id="${cid}"]`).addClass('active');

                if (cid == 'all') {
                    $('.js-result-section').show();
                } else {
                    $('.js-result-section').hide();
                    $(`.js-result-section#${cid}`).show();
                }

            })

            var postsPerPage = isMobileDevice() ? 3 : 6;
            var postsPerPagePremium = isMobileDevice() ? 1 : 4;
            var resizeTimer;


            // Handle section navigation
            $('.js-result-section').hide(); // Hide all sections initially

            // Handle pagination navigation
            $(document).on('click', 'a.page-numbers', function (e) {
                e.preventDefault();

                var section = $(this).parents('.js-result-section').data('section');
                var url = $(this).attr('href');
                var hasPageInUrl = url.lastIndexOf("/page/");
                const index = url.lastIndexOf("/page/") + "/page/".length;

                const partAfterPage = url.substring(index);

                var page = partAfterPage.replace(/\/$/, "");

                if (hasPageInUrl == "-1") {
                    page = 1;
                }

                loadPage(section, page);
            });

            // Load a specific page for the given section
            function loadPage(section, page) {

                var data = {
                    action: 'load_search_results',
                    section: section,
                    page: page,
                    postsPerPage: postsPerPage,
                    postsPerPagePremium: postsPerPagePremium,
                    search_query: $('.js-search').val(),
                    current_url: localize.current_url,
                };

                var loader = $(`<div class="loader js-loader show">
                                    <div class="spinner">
                                        <div class="spinner__inner">
                                            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                </div>`);

                // Create a loader element

                var resultsContainer = $('.js-result-section[data-section="' + section + '"] .js-result');
                resultsContainer.html(loader); // Show loader while loading the search results

                if (page > 1) {
                    $('.js-result-section[data-section="' + section + '"]').get(0).scrollIntoView({ behavior: 'instant', block: 'start' });
                }
                $.post(localize.ajaxurl, data, function (response) {

                    resultsContainer.html(response); // Update the results container with the loaded content
                });
            }

            // Check if the device is mobile
            function isMobileDevice() {
                return window.innerWidth < 768; // Adjust the breakpoint if needed
            }

            // Show all sections and load their content on page load
            $('.js-result-section').each(function () {
                var section = $(this).data('section');
                $(this).show();
                loadPage(section, 1);
            });


        }

    });
})(jQuery);





